import { render, staticRenderFns } from "./PurchaseOrder.vue?vue&type=template&id=7061b838&scoped=true&"
import script from "./PurchaseOrder.vue?vue&type=script&lang=js&"
export * from "./PurchaseOrder.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseOrder.vue?vue&type=style&index=0&id=7061b838&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7061b838",
  null
  
)

export default component.exports